import ApiCore from './api-core'
import { DRIVER } from '@/constants/api-types'

export default class LoadPoint extends ApiCore {
  constructor(store) {
    const path = `${DRIVER}/order/point`
    super(store, path)
  }

  report(filter, showProgress) {
    return this.request({
      action: 'report',
      method: 'GET',
      params: filter,
      showProgress
    })
  }
}
